import axios from 'axios';

export default class AuthService {
  /**
   * ログイン処理
   * @param {*} email メールアドレス 
   * @param {*} password パスワード
   * @param {*} callBackFunction 認証実行後処理関数
   */
  login(email, password, callBackFunction) {
    const API_AUTH = process.env.AUTH_API_ENDPOINT + '/token/get';

    const params = {
      email: email,
      password: password,
    };
    axios
      .post(API_AUTH, params, { headers: { 'content-type': 'application/json' } })
      .then((response) => {
        let isLoggedIn = false;
        if (response.status == 200) {
          const idToken = response.data['IdToken'];
          const refreshToken = response.data['RefreshToken'];
          localStorage.setItem('idToken', idToken);
          localStorage.setItem('refreshToken', refreshToken);
          isLoggedIn = true;
        } else {
          isLoggedIn = false;
        }

        callBackFunction(isLoggedIn);
      })
      .catch(
      (error) => {
        console.log(error);
        callBackFunction(false);
      })
  }

  refreshToken(callBackFunction) {
    const API_AUTH = process.env.AUTH_API_ENDPOINT + '/token/update';

    const params = {
      refresh_token: localStorage.getItem('refreshToken'),
    };

    axios.post(API_AUTH, params, { headers: { 'content-type': 'application/json' } })
      .then((response) => {
        if (response.status == 200) {
          const idToken = response.data['IdToken'];
          localStorage.setItem('idToken', idToken);
          callBackFunction(response);
        } else {
          callBackFunction(response);
        }
      })
      .catch((error) => {
        console.log(error);
        callBackFunction(error.response);
      })
  }
  
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js